import { render, staticRenderFns } from "./SupplierManufacturingPest.vue?vue&type=template&id=670dc1af&scoped=true&"
import script from "./SupplierManufacturingPest.vue?vue&type=script&lang=js&"
export * from "./SupplierManufacturingPest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670dc1af",
  null
  
)

export default component.exports